import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { getMostPreferredCategory } from '@/pages/Onboarding/utils/getMostPreferredCategory';
import { getMostPrefferedInterest } from '@/pages/Onboarding/utils/getMostPrefferedInterest';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { LayoutDataType } from '../../types';

const ReplikaNoLimitsStyles = styled(OnboardingPage)`
  padding: 0;

  .local-content {
    margin: auto 0 36px;
  }

  .local-subtitle {
    max-width: unset;
  }
`;

export const OnboardingReplikaNoLimits: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'No Limits',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  const { watch } = useFormContext<LayoutDataType>();
  const interests = watch('interests');
  const categories = watch('categories');

  const mostPreferredInterest = getMostPrefferedInterest(interests);
  const mostPreferredCategory = getMostPreferredCategory(categories);

  // preload images for chat vibe
  React.useEffect(() => {
    preloadImage(
      `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${mostPreferredCategory.key}/phone-chat.png`,
    );
    preloadImage(
      `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-interest/${mostPreferredInterest}.png`,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ReplikaNoLimitsStyles
      bgImage={
        <img
          src={`https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${mostPreferredCategory.key}/no-limit.png`}
          alt="No Limit"
        />
      }
    >
      <div className="local-content">
        <OnboardingTitle color="black">There is no limit</OnboardingTitle>
        <OnboardingSubtitle color="neutral-black" className="local-subtitle">
          Characters are here 24/7, always available to talk and to listen and
          up for anything you would like
        </OnboardingSubtitle>
      </div>

      <OnboardingFooter onContinue={handleNextStep} />
    </ReplikaNoLimitsStyles>
  );
};
